import React from "react";

const Penalty = () => {
  return (
    <svg
      width="14"
      viewBox="0 0 170 78"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M84.9618 77.6554C82.5098 77.6554 80.1094 76.9631 78.039 75.6497L6.87353 30.3629C0.714199 26.7398 -1.33676 18.8085 2.28637 12.6492C5.90951 6.48983 13.8408 4.43887 20.0001 8.06201C20.2654 8.21729 20.5306 8.3855 20.783 8.56019L84.961 49.3836L149.204 8.49549C155.24 4.65238 163.249 6.43808 167.092 12.4745C170.935 18.5109 169.15 26.5198 163.113 30.3629L91.9477 75.6497C89.8595 76.9695 87.4333 77.6683 84.9618 77.6554Z"
        fill="#474747"
      />
      <path
        d="M84.9618 72.2098C82.5098 72.2098 80.1094 71.5175 78.039 70.2041L6.87353 24.9173C0.714199 21.2942 -1.33676 13.3629 2.28637 7.2036C5.90951 1.04427 13.8408 -1.00668 20.0001 2.61645C20.2654 2.77173 20.5306 2.93995 20.783 3.11463L84.961 43.938L149.204 3.04993C155.24 -0.793181 163.249 0.992519 167.092 7.02892C170.935 13.0653 169.15 21.0742 163.113 24.9173L91.9477 70.2041C89.8595 71.524 87.4333 72.2227 84.9618 72.2098Z"
        fill="#E16A3C"
      />
      <path
        d="M167.06 7.06116C165.682 4.91962 163.703 3.23098 161.367 2.20874C164.026 8.05752 161.988 14.973 156.579 18.4473L77.9741 70.204C82.2184 72.9084 87.6393 72.9084 91.8836 70.204L163.049 24.9172C169.086 21.0935 170.884 13.1032 167.06 7.06116Z"
        fill="black"
        fillOpacity="0.24"
      />
    </svg>
  );
};

export default Penalty;
